
import { PropType, defineComponent } from '@vue/composition-api';
import HelpDialog from './HelpDialog.vue';

export default defineComponent({
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    value: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    options: {
      type: Array as PropType<Array<{
        label: string; value: string;
        helpText?: string;
      }>>,
      required: true,
    },
  },
  components: {
    HelpDialog,
  },
});
